module.exports = __webpack_public_path__ + "img/main-pic.7fada484.png";